<template>
  <div>
    <zx-table
      :tableData="tableData"
      :option="table"
      :page="page"
      @searchSubmit="searchSubmit"
      @handleSelectionChange="handleSelectionChange"
      @delBtn="delBtn"
      @refresh-change="getlist"
      @addSubmit="addSubmit"
      @etidSubmit="etidSubmit"
      @refreshBtn="refreshBtn"
    >
    </zx-table>
  </div>
</template>

<script>
import * as current from "@/api/current.js";
import * as tableDataList from "../assets/testData.js";
import xzTable from "@/components/xz-table.vue";
export default {
  created() {
    this.getlist();
  },
  components: {
    "zx-table": xzTable
  },
  data() {
    return {
      table: {
        // 表格底部按钮
        btnBottom: false,
        // 操作按钮列定位 默认:false;
        fixed: false,
        // 子表格 默认: ; 数据格式:String;<对应子行字段名称>
        children: "children",
        // 多选 默认:false;
        selection: true,
        // 单选高亮
        current: true,
        //搜索框 默认:false;
        searchBtn: false,
        // 表格高度 默认:100%; 数据格式:Number;
        // height:500,
        // 数边框 默认:false;
        border: false,
        //索引 默认:true;
        index: true,
        // 刷新 默认:true;
        refreshBtn: true,
        // 添加 默认:true;
        addBtn: true,
        // 编辑 默认:true;
        editBtn: true,
        // 删除  默认:true;
        delBtn: true,
        // 折叠筐 默认:false;
        expand: false,
        column: [
          {
            // 字段
            prop: "name",
            // 列名
            label: "项目名称",
            // 表单 类型
            type: "input",
            // 是否必须输入
            required: true,
            // 表格是否显示
            hide: true,
            // 该字段是否可以在创建时编辑 默认:true;
            addDisplay: true,
            // 倒叙 默认:false;
            sortable: false,
            // 该字段是否可以在筛选 默认:false;
            searchDisplay: true,
            // 表格显示类型 默认文字 支持 下拉框dropdown 输入框 input图片:image; 标签:tag;
            width: "180"
          },
          {
            prop: "id",
            label: "ID",
            sortable: true,
            type: "input",
            addDisplay: false,
            show: "checkbox",
            // 该字段是否可以在创建时编辑 默认:true;
            hide: false
          },
          {
            prop: "miaoshu",
            label: "描述",
            type: "input",
            addDisplay: true,
            // show:'checkbox',
            // 该字段是否可以在创建时编辑 默认:true;
            hide: true,
            width: "180"
          },
          {
            prop: "update_time",
            label: "跟新时间",
            type: "input",
            addDisplay: false,
            hide: true,
            width: "180"
          },
          {
            prop: "create_time",
            label: "创建时间",
            addDisplay: false,
            type: "input",
            // "addDisplay": true,
            hide: true,
            width: "180"
          }
        ],
        btnList: [
          {
            name: "查看",
            type: "text",
            size: "small",
            click: (id, row, index) => {
              this.$router.push("/project/databaseList");
            }
          }
        ]
      },
      //
      tableData: tableDataList.tableData,
      searchData: null
    };
  },

  methods: {
    // 筛选条件
    searchSubmit(e) {
      this.searchData = e;
      this.getlist();
    },
    // 多选
    handleSelectionChange(e) {},
    // 添加提交
    addSubmit(form) {
      current.addCurrent.r(form).then(res => {
        this.$message.success("账号" + res.name + "创建成功");
        this.getlist();
      });
    },
    // 编辑
    etidSubmit(form) {
      current.editCurrent.r(form).then(res => {
        this.$message.success("修改成功");
        this.getlist();
      });
    },
    // 删除
    delBtn(form) {
      current.deleteCurrent
        .r({
          id: form.id
        })
        .then(res => {
          this.$message({
            type: "success",
            message: "删除成功!"
          });
          this.getlist();
        });
    },
    // 刷新
    refreshBtn(e) {
      this.getlist();
    },
    async getlist(e) {
      // this.tableData  = tableDataList.tableData
      // 	if(e)this.page = e;
      // 	let param = {
      // 		page: this.page.currentPage,
      // 		limit: this.page.pageSize,
      // 	};
      // 	if(this.searchData){
      // 		param = {
      // 			page: this.page.currentPage,
      // 			limit: this.page.pageSize,
      // 			...this.searchData
      // 		}
      // 	}
      // 	let res = await current.request.r(param)
      // 	this.tableData = res.list
      // 	this.page.total = res.total
    }
  }
};
</script>
<style></style>
